import React from "react"
import Layout from "@yumgmbh/gatsby-theme-yum-components/src/components/modules/Layout"
import BodyBlocks from "@yumgmbh/gatsby-theme-yum-components/src/components/technical/BodyBlocks"
import Breadcrumbs from "@yumgmbh/gatsby-theme-yum-components/src/components/modules/Breadcrumbs"
import SEO from "@yumgmbh/gatsby-theme-yum-components/src/components/modules/Seo"
import BlockWrapper from "@yumgmbh/gatsby-theme-yum-components/src/components/technical/BlockWrapper"
import HeadlineEnhanced from "@yumgmbh/gatsby-theme-yum-components/src/components/molecules/HeadlineEnhanced"

const DefaultPage = ({ content, name, breadcrumbs }) => {
  return (
    <Layout>
      <SEO content={content} name={name} />
      <Breadcrumbs breadcrumbs={breadcrumbs}></Breadcrumbs>
      <BlockWrapper block={{}} blockPadding="pt-12 pb-0">
        <HeadlineEnhanced headline={content.headline} tagName="h1" />
      </BlockWrapper>
      <BodyBlocks body={content.body} />
    </Layout>
  )
}

export default DefaultPage
